import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageGreeting } from '../../models/page-greeting.model';

/**
 * The left half of the sign-in layout: the logo and the route's `data.greeting`.
 * Place it inside a `<div class="main">`; the layout comes from the global `.main .left-hlf` rules.
 */
@Component({
    selector: 'app-page-greeting',
    templateUrl: './page-greeting.component.html',
    styleUrls: ['./page-greeting.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageGreetingComponent {
  private route = inject(ActivatedRoute);
  protected greeting: PageGreeting | null = this.route.snapshot.data['greeting'] ?? null;
}
